import { isDate, isNumber, isString, isUndefined } from '@fxts/core';
import { AbstractBaseInputView } from './views/AbstractBaseInputView';
import { BaseInputAttribute, BaseInputProps, DateInputAttribute, NumberInputAttribute } from './types';
import { DateInputView } from './views/DateInputView';
import { NumberInputView } from './views/NumberInputView';
import { TextInputView } from './views/TextInputView';

export class BaseInputFactory {
  public static create(
    type: 'number',
    value?: number,
    attribute?: NumberInputAttribute,
    option?: BaseInputProps,
  ): NumberInputView;

  public static create(
    type: 'date',
    value?: Date,
    attribute?: DateInputAttribute,
    option?: BaseInputProps,
  ): DateInputView;

  public static create(
    type: 'text',
    value?: string,
    attribute?: BaseInputAttribute,
    option?: BaseInputProps,
  ): TextInputView;

  public static create(
    type: 'number' | 'date' | 'text',
    value?: number | Date | string,
    attribute?: BaseInputAttribute,
    option?: BaseInputProps,
  ): AbstractBaseInputView {
    if (type === 'number') {
      if (isNumber(value) || isUndefined(value)) {
        return new NumberInputView(value, attribute, option);
      }
      throw new TypeError(`Expected number for type 'number', but received ${typeof value}, ${value}`);
    } else if (type === 'date') {
      if (isDate(value) || isUndefined(value)) {
        return new DateInputView(value, attribute, option);
      }
      // rune에서 date를 string으로 넘겨줘서 임시로 이렇게
      if (isString(value)) {
        return new DateInputView(new Date(value), attribute, option);
      }
      throw new TypeError(`Expected date for type 'date', but received ${typeof value}`);
    } else if (type === 'text') {
      if (isString(value) || isUndefined(value)) {
        return new TextInputView(value, attribute, option);
      }
      throw new TypeError(`Expected string for type 'text', but received ${typeof value}`);
    }

    throw new Error(`Unsupported type: ${type}`);
  }
}
